import { render, staticRenderFns } from "./MapSuborderInfo.vue?vue&type=template&id=58705ddc&scoped=true"
import script from "./MapSuborderInfo.vue?vue&type=script&lang=js"
export * from "./MapSuborderInfo.vue?vue&type=script&lang=js"
import style0 from "./MapSuborderInfo.vue?vue&type=style&index=0&id=58705ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58705ddc",
  null
  
)

export default component.exports